import React from 'react';
import { Accordion } from '@tvg/fuse/accordion';
import styles from './InlineContentStyles.module.css';

type AccordionProps = React.ComponentPropsWithoutRef<typeof Accordion>;

export function StyledAccordion({ className, ...props }: AccordionProps) {
  return <Accordion className={[styles.accordion, className].filter(Boolean).join(' ')} {...props} />;
}

export const FeaturesContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={[styles.featuresContainer, className].filter(Boolean).join(' ')} {...props} />
  ),
);
FeaturesContainer.displayName = 'FeaturesContainer';

export const Container = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={[styles.container, className].filter(Boolean).join(' ')} {...props} />
  ),
);
Container.displayName = 'Container';

export const AccordionWrapperDiv = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={[styles.wrapper, className].filter(Boolean).join(' ')} {...props} />
  ),
);
AccordionWrapperDiv.displayName = 'AccordionWrapperDiv';

export const LinksContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={[styles.linksContainer, className].filter(Boolean).join(' ')} {...props} />
  ),
);
LinksContainer.displayName = 'LinksContainer';

export const TechSpecsContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={[styles.techSpecsContainer, className].filter(Boolean).join(' ')} {...props} />
  ),
);
TechSpecsContainer.displayName = 'TechSpecsContainer';

export const DocsContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={[styles.docsContainer, className].filter(Boolean).join(' ')} {...props} />
  ),
);
DocsContainer.displayName = 'DocsContainer';
